import { Component, Input } from '@angular/core';
import { BehaviorSubject, filter, map, Subject } from 'rxjs';
import { Job } from 'server/shared/models/job';
import { JobStatusEnum } from 'server/shared/models/jobStatusEnum';
import { filterIsNotEmpty } from '../../../helpers/filterIsNotEmpty';
import { Column } from '../../../helpers/job/jobColumns';
import { CustomerService } from '../../services/customer.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-pooler-job-list-item-compact-content',
  templateUrl: './pooler-job-list-item-compact-content.component.html',
  styleUrls: [
    './pooler-job-list-item-compact-content.component.scss',
    '../../../stylesheets/components/atoms/jobs-list-view.scss',
  ],
})
export class PoolerJobListItemCompactContentComponent {
  private destroyed$ = new Subject<void>();

  job$ = new BehaviorSubject<Job | undefined>(undefined);
  @Input() set job(job: Job | undefined) {
    this.job$.next(job);
  }
  get job(): Job | undefined {
    return this.job$.getValue();
  }

  columns$ = new BehaviorSubject<Column[]>([]);
  @Input() set columns(columns: Column[]) {
    this.columns$.next(columns);
  }
  get columns(): Column[] {
    return this.columns$.value;
  }

  jobCertificates$ = this.job$.pipe(
    filter(filterIsNotEmpty),
    map((job) => {
      if (!job.certificates?.length) {
        return;
      }
      return job.certificates.map((c) => c.displayName).join(', ');
    }),
  );

  constructor(
    private customerService: CustomerService,
    private userService: UserService,
  ) {}

  readonly JobStatusEnum = JobStatusEnum;
  trackByColumnKey = (index: number, column: Column) => column.key;
}
